<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import MenuCard from '../menu/menuCard/index.vue';

export default {
  name: 'LinkMenu',
  components: { MenuCard },
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      activeMenuItem: '',
      currentRoute: '',
    };
  },
  watch: {
    $route (to, from){
      this.currentRoute = to.path
    }
  },
  computed: {
    ...mapGetters(['get_user', 'get_navigation', 'get_user_permissions']),
    navigationLinks() {
      let linksArray = [];

      // Second menu filter
      let navLinks = JSON.parse(JSON.stringify(this.get_navigation.leftLinks[4]));
      let isSecondMenu = false;
      let shipmentSettings = [];  // 3
      let systemSettings = [];    // 3
      let integrationSettings = [];// 3
      let pickupSettings = [];
      let settings = [];          // 2
      let shipments = [];         // 2
      let finance = [];         // 2
      let secondPanels = [];      // 1

      //console.log(navLinks)

      // //pickups settings submenu object is navLinks.panels[7]
      navLinks.panels[7].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          pickupSettings.push(menuItem)
        }
      })

      //integration settings submenu object is navLinks.panels[6]
      navLinks.panels[6].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          integrationSettings.push(menuItem)
        }
      })
      //shipping settings submenu object is navLinks.panels[4]
      navLinks.panels[5].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          shipmentSettings.push(menuItem)
        }
      })
      //system settings submenu object is navLinks.panels[3]
      navLinks.panels[4].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          systemSettings.push(menuItem)
        }
      })
      //finances submenu object is navLinks.panels[1]
      navLinks.panels[3].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          finance.push(menuItem)
        }
      })
      //shipment submenu object is navLinks.panels[1]
      navLinks.panels[1].links.forEach((menuItem, index) => {
        if(this.checkPermission(menuItem.permission)){
          isSecondMenu = true;
          shipments.push(menuItem)
        }
      })

      let menuObject = JSON.parse(JSON.stringify(this.get_navigation.leftLinks[4]));

      //*** SECOND LEVEL LINKS ***//
      if(isSecondMenu){
        let settingsLinks = [];
        if(shipmentSettings.length > 0) {
          menuObject.panels[2].links[1].permission = true;
          settingsLinks.push(menuObject.panels[2].links[1])
          menuObject.panels[5].links = shipmentSettings;
        } else {
          menuObject.panels[2].links[1].permission = false;
        }
        if(systemSettings.length > 0) {
          menuObject.panels[2].links[0].permission = true;
          settingsLinks.push(menuObject.panels[2].links[0])
          menuObject.panels[4].links = systemSettings;
        } else {
          menuObject.panels[2].links[0].permission = false;
        }
        if(integrationSettings.length > 0) {
          menuObject.panels[2].links[2].permission = true;
          settingsLinks.push(menuObject.panels[2].links[2])
          menuObject.panels[6].links = integrationSettings;
        } else {
          menuObject.panels[2].links[2].permission = false;
        }
        menuObject.panels[2].links = settingsLinks;
        if(shipments.length > 0){
          menuObject.panels[1].links = shipments;
        }
        if(pickupSettings.length > 0){
          menuObject.panels[7].links = pickupSettings;
        }
        if(finance.length > 0){
          //console.log('menu', finance)
          menuObject.panels[3].links = finance;
        }
      }

      let mainLevelLinks = [];
      //Dashboard
      if(this.checkPermission(navLinks.panels[0].links[0].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[0])
      }
      //If shipments have some submenu options than show main menu option
      if(shipments.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[1])
      }
      //Pickups
      if (pickupSettings.length > 0) {
        mainLevelLinks.push(menuObject.panels[0].links[7])
      }
      //Items(Products)
      if (this.checkPermission(navLinks.panels[0].links[6].permission)) {
        mainLevelLinks.push(navLinks.panels[0].links[6])
      }
      if(finance.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[5])
      }
      //Contacts
      if(this.checkPermission(navLinks.panels[0].links[2].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[2])
      }
      //Reports
      if(this.checkPermission(navLinks.panels[0].links[4].permission)){
        mainLevelLinks.push(navLinks.panels[0].links[4])
      }
      //Settings
      if(shipmentSettings.length > 0 || systemSettings.length > 0){
        mainLevelLinks.push(menuObject.panels[0].links[3])
      }

      //New main menu option needs to be added here
      //If it is multi level option, probably should be added in second level links also

      if(mainLevelLinks.length > 0){
        menuObject.panels[0].links = mainLevelLinks;
      }

      //console.log(menuObject)
      linksArray.push(menuObject)

      if (this.checkPermission(this.get_navigation.leftLinks[0].panels[0].permission)) {
        linksArray.push(this.get_navigation.leftLinks[0])
      }

      if (this.checkPermission(this.get_navigation.leftLinks[1].panels[0].permission)) {
        linksArray.push(this.get_navigation.leftLinks[1])
      }

      if (this.checkPermission(this.get_navigation.leftLinks[2].panels[0].permission)) {
        linksArray.push(this.get_navigation.leftLinks[2])
      }

      if (this.checkPermission(this.get_navigation.leftLinks[3].panels[0].permission)) {
        linksArray.push(this.get_navigation.leftLinks[3])
      }

      return linksArray;
    },
  },
  methods: {
    navigateLink(link) {
      this.currentRoute = link;
      this.$router.push(link)
    },
    checkPermission(permission) {
      //routes available only for backoffice 1
      if (['settings/account', 'finance/invoices', 'shipment/shared'].includes(permission) && parseInt(this.get_user.backoffice_id) !== 1) {
        return false
      }

      if (['shipment/consolidations'].includes(permission) && ![1, 3].includes(parseInt(this.get_user.backoffice_id))) {
        return false
      }

      if (['pickup/booked'].includes(permission) && parseInt(this.get_user.backoffice_id) === 1) {
        return false
      }

      let result = false;

      this.get_user_permissions.forEach((perm) => {
        if(perm.acl_route_group == permission) result = perm.view;
      })
      return result;
    },
    filterMenu(panel) {
      // First level
      //console.log(panel[0].links)
    },
    closeMenu() {
      this.$store.dispatch('SET_LEFT_ACTIVE_MENU', '');
      this.$store.dispatch('CLOSE_LEFT_NAVIGATION');
    },
    openMenu(type) {
      if (this.get_navigation.activeLeftMenuItem === type && this.get_navigation.isLeftOpen) {
        // CLOSE MENU
        this.$store.dispatch('SET_LEFT_ACTIVE_MENU', '');
        this.$store.dispatch('CLOSE_LEFT_NAVIGATION');
      } else {
        // OPEN MENU
        this.$store.dispatch('SET_LEFT_ACTIVE_MENU', type);
        this.$store.dispatch('OPEN_LEFT_NAVIGATION');
      }
    },
  },
};
</script>
